var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"md-title",on:{"click":function($event){return _vm.$router.push('/bible')}}},[_c('md-icon',[_vm._v("arrow_back")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }